import React from 'react';
import Image from 'next/image';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';

const QR_FLOW_URL = 'https://qr-flow.eu';

const QrFlowAbout = () => {
    const { t } = useTranslations();

    const highlights = [
        t('qrFlow_about_highlight1'),
        t('qrFlow_about_highlight2'),
        t('qrFlow_about_highlight3'),
        t('qrFlow_about_highlight4'),
    ];

    return (
        <section className="qr-flow-about">
            <div className="container">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6">
                        <FadeInAnimation direction="right" delay={50}>
                            <span className="qr-flow-about__badge">{t('qrFlow_about_badge')}</span>
                            <h2 className="qr-flow-about__title">{t('qrFlow_about_title')}</h2>
                            <p className="qr-flow-about__text">{t('qrFlow_about_p1')}</p>
                            <p className="qr-flow-about__text">
                                {t('qrFlow_about_p2_prefix')}
                                <a
                                    href={QR_FLOW_URL}
                                    className="qr-flow-about__inline-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    qr-flow.eu
                                </a>
                                {t('qrFlow_about_p2_suffix')}
                            </p>
                            <ul className="qr-flow-about__list">
                                {highlights.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <a
                                href={`${QR_FLOW_URL}/demos/`}
                                className="qr-flow-about__link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t('qrFlow_about_cta')}
                            </a>
                        </FadeInAnimation>
                    </div>
                    <div className="col-lg-6">
                        <FadeInAnimation direction="left" delay={100}>
                            <figure className="qr-flow-about__figure">
                                <Image
                                    src="/images/qr-flow/qr-generator.webp"
                                    alt={t('qrFlow_showcase_item1_imageAlt')}
                                    width={1440}
                                    height={900}
                                    className="qr-flow-about__image"
                                    sizes="(max-width: 992px) 100vw, 50vw"
                                />
                                <figcaption>{t('qrFlow_showcase_item1_caption')}</figcaption>
                            </figure>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QrFlowAbout;
